import React, { useEffect, useState } from "react";
import "./ExploreTopCitiesBlue.css";
import HomeService from "../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const ExploreTopCitiesBlue = () => {
  const [citiesWithCityDetails, setCitiesWithCityDetails] = useState([]);
  const navigate = useNavigate();

  const fetchCitiesWithCityDetails = async () => {
    try {
      const res = await HomeService.getCitiesWithCityDetails();

      if (res?.status) {
        setCitiesWithCityDetails(res?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCitiesWithCityDetails();
  }, []);

  const totalLocalities = citiesWithCityDetails.reduce(
    (acc, city) => acc + (city?.locations || 0),
    0
  );

  return (
    <section className="cities_section_blue">
      <div className="cities_container_blue">
        <div className="cities_header_blue">
          <div>
            <span className="cities_badge_blue">
              Active Coverage
            </span>

            <h2 className="cities_title_blue">
              Explore Top Cities
            </h2>

            <p className="cities_subtitle_blue">
              Discover premium locations and localities across India.
            </p>
          </div>

          <div className="cities_stats_blue">
            <div className="cities_stat_card_blue">
              <h3>{citiesWithCityDetails.length}+</h3>
              <p>Cities</p>
            </div>

            <div className="cities_stat_card_blue">
              <h3>500+</h3>
              <p>Localities</p>
            </div>
          </div>
        </div>

        <div className="cities_grid_blue">
          {citiesWithCityDetails?.map((city, index) => (
            <div
              key={index}
              className="city_card_blue"
              onClick={() => {
                const citySlug = city?.cityData?.name
                  ?.trim()
                  ?.replace(/\s+/g, "-");

                navigate(`/${citySlug}`, {
                  state: {
                    id: city?.cityData?._id,
                  },
                });
              }}
            >
              <img
                src={city?.cityData?.image}
                alt={city?.cityData?.name}
                className="city_image_blue"
              />

              <div className="city_overlay_blue"></div>

              <div className="city_content_blue">
                <span className="city_count_blue">
                  {city?.locations || 0} Localities
                </span>

                <h3>{city?.cityData?.name}</h3>

                <button className="city_button_blue">
                  Explore
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreTopCitiesBlue;